import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.214 3.05454C10.459 2.63506 9.54085 2.63506 8.7858 3.05454L3.78579 5.83231C3.0038 6.26675 2.47072 7.11295 2.53129 8.06901C2.62457 9.54127 2.95725 11.278 3.9377 12.9304C4.92529 14.5948 6.53731 16.1177 9.09327 17.2019C9.67222 17.4475 10.3276 17.4475 10.9065 17.2019C13.4625 16.1177 15.0745 14.5948 16.0621 12.9304C17.0426 11.278 17.3752 9.54127 17.4685 8.06901C17.5291 7.11295 16.996 6.26675 16.214 5.83231L11.214 3.05454ZM9.5952 4.51146C9.84689 4.37164 10.1529 4.37164 10.4046 4.51146L15.4046 7.28924C15.6808 7.4427 15.8211 7.71156 15.8052 7.96363C15.722 9.27607 15.4303 10.729 14.6288 12.0799C13.8343 13.4188 12.5067 14.7127 10.2557 15.6676C10.0927 15.7367 9.9071 15.7367 9.74411 15.6676C7.4931 14.7127 6.16547 13.4188 5.37104 12.0799C4.56947 10.729 4.27778 9.27607 4.19463 7.96363C4.17865 7.71156 4.31897 7.4427 4.5952 7.28924L9.5952 4.51146Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M7.91657 9.16666C7.45634 9.16666 7.08324 9.53976 7.08324 10C7.08324 10.4602 7.45634 10.8333 7.91657 10.8333H9.16657V12.0799C9.16657 12.5401 9.53966 12.9132 9.9999 12.9132C10.4601 12.9132 10.8332 12.5401 10.8332 12.0799V10.8333H12.0832C12.5435 10.8333 12.9166 10.4602 12.9166 10C12.9166 9.53976 12.5435 9.16666 12.0832 9.16666H10.8332V7.91673C10.8332 7.45649 10.4601 7.08339 9.9999 7.08339C9.53966 7.08339 9.16657 7.45649 9.16657 7.91673V9.16666H7.91657Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}